import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class RefrigeratorsService {
  private serviceModel: string;

  constructor(private commonService: CommonService,
              private httpClient: HttpClient) {
    this.serviceModel = 'refrigerator';
  }

  public getRefrigerator(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}/refrigerator2?first=true&filter=id=${id}`).subscribe((result) => {
        resolve(result);
      });
    });
  }

  public async updateRefrigeratorSerialNumber(model: UpdateEntities) {
    return new Promise((resolve) => {
      this.httpClient.put(`refrigerator/join_sap`, model).subscribe(result => {
        resolve(result);
      });
    });
  }

  public initializeRefrigerator(refrigerator: any): any {
    return {
      title: 'Στοιχεία Ψυγείου',
      values: [
        {
          name: 'Σειριακός Αριθμός',
          value: this.commonService.setValue(refrigerator.serial_number)
        },
        {
          name: 'Κωδικός Είδους',
          value: this.commonService.setValue(refrigerator.material_id)
        },
        {
          name: 'Περιγραφή Είδους',
          value: this.commonService.setValue(refrigerator.material_name)
        },
        {
          name: 'Παρτίδα',
          value: this.commonService.setValue(refrigerator.batch_name)
        },
        {
          name: 'Κωδικός Εικαστικού',
          value: this.commonService.setValue(refrigerator.eikastiko_id)
        },
        {
          name: 'Περιγραφή Εικαστικού',
          value: this.commonService.setValue(refrigerator.eikastiko_name)
        },
        {
          name: 'Καθαρό Βάρος',
          value: this.commonService.setValue(refrigerator.weight_net)
        },
        {
          name: 'Κωδικός Μοντέλου',
          value: this.commonService.setValue(refrigerator.model_id)
        },
        {
          name: 'Περιγραφή Μοντέλου',
          value: this.commonService.setValue(refrigerator.model_name)
        },
        {
          name: 'Κωδικός Κατάστασης',
          value: this.commonService.setValue(refrigerator.quality_id)
        },
        {
          name: 'Περιγραφή Κατάστασης',
          value: this.commonService.setValue(refrigerator.quality_name)
        },
        {
          name: 'Κωδικός Κατασκευαστή',
          value: this.commonService.setValue(refrigerator.manufacturer_id)
        },
        {
          name: 'Περιγραφή Κατασκευαστή',
          value: this.commonService.setValue(refrigerator.manufacturer_name)
        },
        {
          name: 'Κωδικός SAP',
          value: this.commonService.setValue(refrigerator.equipment_id)
        },
        {
          name: 'Επωνυμία Σημείου Πώλησης',
          value: this.commonService.setValue(refrigerator.sale_point_customer_name)
        },
        {
          name: 'Δρομολόγιο',
          value: this.commonService.setValue(refrigerator.sales_group_description)
        },
        {
          name: 'Κατηγορία',
          value: this.commonService.setValue(refrigerator.evaluation_category_name)
        },
        {
          name: 'LED',
          value: this.commonService.setValue(refrigerator.is_led_name)
        },
        {
          name: 'Θήκες',
          value: this.commonService.setValue(refrigerator.has_cases_name)
        },
        {
          phantom: true
        },
        {
          phantom: true
        }
      ]
    };
  }
}
